const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.987 511.987",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M42.659,138.662v319.999c0,29.452,95.513,53.326,213.33,53.326 c117.81,0,213.337-23.874,213.337-53.326V138.662H42.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M255.989,191.996c13.765,0,27.218-0.328,40.25-0.953l91.996-10.53 c49.391-9.773,81.092-24.882,81.092-41.851c0-29.453-95.527-53.334-213.337-53.334c-117.817,0-213.33,23.882-213.33,53.334 S138.171,191.996,255.989,191.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M255.989,191.996c13.765,0,27.218-0.328,40.25-0.953l91.996-10.53 c38.75-7.672,66.607-18.625,76.811-31.187c-19.766-24.343-105.84-42.663-209.056-42.663c-103.208,0-189.292,18.32-209.057,42.663 C66.697,173.669,152.781,191.996,255.989,191.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M212.169,42.267c-6.117-28.812-34.437-47.21-63.248-41.093c-28.812,6.117-47.21,34.437-41.085,63.248 l25.015,117.793c31.718,5.617,69.841,9.125,111.098,9.695L212.169,42.267z M162.218,63.774c-5.766,1.227-11.429-2.453-12.648-8.218 c-1.227-5.758,2.453-11.421,8.218-12.648c5.758-1.219,11.422,2.453,12.648,8.218C171.655,56.891,167.983,62.555,162.218,63.774z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M85.329,170.67v31.991c0,5.891,4.773,10.664,10.664,10.664s10.664-4.773,10.664-10.664v-25.913 C98.953,174.857,91.821,172.826,85.329,170.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M127.992,181.333v149.332c0,5.89,4.773,10.655,10.664,10.655s10.672-4.766,10.672-10.655V184.856 C141.921,183.786,134.796,182.606,127.992,181.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M255.989,191.996v31.999c0,5.891,4.773,10.664,10.664,10.664c5.898,0,10.68-4.773,10.68-10.664 V191.73C270.308,191.903,263.191,191.996,255.989,191.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M362.642,184.856v60.467c0,5.891,4.781,10.671,10.688,10.671c5.873,0,10.654-4.78,10.654-10.671 v-63.991C377.172,182.606,370.049,183.786,362.642,184.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M405.328,176.747v4.75l0,0c0.094,5.812,4.812,10.5,10.656,10.5s10.562-4.687,10.656-10.5l0,0 v-10.835C420.156,172.826,413.015,174.857,405.328,176.747z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/Paint.d8d9333a2f0884075ef047678d6928d9.svg";
export { ForwardRef as ReactComponent };